jQuery(document).on('click', '#search-client-btn', function(e) {
  e.preventDefault();

  const ajaxUrl = jQuery('#custom_ajax_var').val();
  if(!ajaxUrl) {
    return;
}
  const clientNumber = jQuery('#client-number').val();
  const spinner = jQuery('#loading-spinner');  // Spinner element
  const successMessage = jQuery('#success-message'); // Success message element
  const clientNumberFeedback = jQuery('.client_number_feedback'); // Feedback element

  // Validation
  if (clientNumber.length < 3 || !/^[0-9]+$/.test(clientNumber)) {
    clientNumberFeedback.text('Klantnummer moet minimaal 3 cijfers bevatten en mag alleen cijfers bevatten.').show();
    return;
  } else {
    clientNumberFeedback.hide();
  }

  // Disable the submit button while searching
  jQuery('button[type="submit"]').prop('disabled', true);

  // Show the spinner while searching
  spinner.show();
  successMessage.hide();

  jQuery.ajax({
      type: 'POST',
      url: ajaxUrl,
      data: {
          action: 'search_client',
          client_number: clientNumber,
      },
      success: function (response) {
          // Hide the spinner after getting the response
          spinner.hide();

          if (response.success) {
              // Populate the form fields with the retrieved data
              jQuery('input[name="client_number"]').val(response.data.code);
              jQuery('input[name="company"]').val(response.data.company_name);
              jQuery('input[name="place"]').val(response.data.place);
              jQuery('input[name="address"]').val(response.data.address);
              jQuery('input[name="zipcode"]').val(response.data.zipcode);
              jQuery('input[name="customer_email"]').val(response.data.email);

              // Show success message
              successMessage.html('Klant gevonden: <span style="font-weight: 600;">' + response.data.company_name + '</span>. Is deze informatie correct?');
              successMessage.show();

              // Re-enable the submit button now that the search has completed
              jQuery('button[type="submit"]').prop('disabled', false);
          } else {
              alert(response.data.message || 'Klant niet gevonden');
              // Re-enable the submit button even if the search fails
              jQuery('button[type="submit"]').prop('disabled', false);
          }
      },
      error: function() {
        spinner.hide();
        alert('Er is een fout opgetreden tijdens het zoeken naar de klant.');
        // Re-enable the submit button if there's an error
        jQuery('button[type="submit"]').prop('disabled', false);
    },
  });
});

jQuery(document).on('input', '#client-number', function() {
    // Clear all form fields
    jQuery('input[name="company"]').val('');
    jQuery('input[name="place"]').val('');
    jQuery('input[name="address"]').val('');
    jQuery('input[name="zipcode"]').val('');
    jQuery('input[name="customer_email"]').val('');
    jQuery('#success-message').hide();
    jQuery('.client_number_feedback').hide();
});